<div class="meetings-container">
  <div class="header">
    <div class="show-only-in-progress">
      <label class="checkbox">
        <input *ngIf="formGroup" [formGroup]="formGroup" [formControl]="formGroup.get('showOnlyInProgress')"
          type="checkbox">
        <span class="checkMark"></span>
      </label>
      <div class="label">Masquer les réunions terminées</div>
    </div>

    <frg-button (activated)="addMeeting()">Ajouter une réunion</frg-button>
  </div>
  <frg-table [keysBody]="meetingsTable" [keysColumn]="meetingsTableColumnTable" [isRowsClickable]="true"
    (onDblClickRow)="goToMeetingEdit($event)" tableButton1="assets/icons/edit.svg" (onClick1)="validMeeting($event)"
    tableButton2="assets/icons/trash.svg" (onClick2)="deleteMeeting($event)" isOkForDblClick="true"
    (onChangePage)="changePage($event)" (onSort)="sortMeetings($event)"></frg-table>
</div>